import { Component, OnInit } from '@angular/core';
import { ActivatedRoute,Router } from '@angular/router';
import { ContractorsVM, ObservationVMwithState, QuestionCategoriesVM, QuestionCommentsVM, QuestionImageVM, QuestionVM, SiteCodes, UsersVM } from '../entities/global/model';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';
import { AddCommentDialogComponent } from './add-comment-dialog/add-comment-dialog.component';
import { AddImageDialogComponent } from './add-image-dialog/add-image-dialog.component';
import { ContractorsInvolvedDialogComponent } from './contractors-involved-dialog/contractors-involved-dialog.component';
import { EditWorkAreaDepartmentDialogComponent } from './edit-work-area-department-dialog/edit-work-area-department-dialog.component';
import { PersonsInvolvedDialogComponent } from './persons-involved-dialog/persons-involved-dialog.component';
import { NotificationsService } from 'angular2-notifications';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-enter-safety-inspection-dashboard',
  templateUrl: './enter-safety-inspection-dashboard.component.html',
  styleUrls: ['./enter-safety-inspection-dashboard.component.css']
})
export class EnterSafetyInspectionDashboardComponent implements OnInit {
  inspectionId:number;
  constructor(
    private _notify: NotificationsService,
    private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private route: ActivatedRoute,
    private _router: Router,
    public dialog: MatDialog,private _safetyConfigService:SafetyConfigService,) { }

    department
    workareas
    TaskObserved
    completedDate
    Inspector
    dataSource = new MatTableDataSource();
    QuestionCategories: QuestionCategoriesVM[] = []
    Questions: QuestionVM[]=[]
    QuestionComments: QuestionCommentsVM
    ContractorsInvolved
    ObservationDetailsID
    contractorsInvolvedList:ContractorsVM[]=[]
    QuestionImageList:QuestionImageVM[]=[]
    users:UsersVM[]=[]
    ObsTypeList=[
      {Id:3, Title:"None",color:"#ffa500" },
      {Id:0, Title:"Unsafe",color:"Red"},
      {Id:1, Title:"Safe", color:"#52ac5a"},
      {Id:2, Title:"N/A",color:"cornflowerblue" },
     
    ]
    type_auto:number;
    CategoryId
    SelectNA:boolean
    FollowUprequired:boolean
personsInvolved
    QuestionName
    Image
    FollowUpRequired
    total;
    safecount;
    unsafecount;
    totalQuestions;
    safeIconcolorChange
    
    CountToggleChangeNAButtonSafe
    showToggleChangeNAButton
    siteCodesList: SiteCodes[]=[];
    siteCodesList_: SiteCodes[]=[];
    inputValuestate
    SiteName:string

  ngOnInit() {
   
    this.route.params.subscribe(params => {
      this.inspectionId = +params['inspectionId'];

      if (this.inspectionId) {
          this.GetInspectionDetail();
          this.GetContarctorsForSafetyApp();
          this.GetInspectionState();
      }
  });
  this.GetUsers();
  this.loadSiteList();
  }

  DoneClick(){
    this._notify.success('Complete', 'Sucessfully completed Safety Inspection')
    this._router.navigate(['safetyobservationdashboardcomponent']);

  }
  getColor(type: any): string {
    // Logic to return color based on type
    if (type == 0) {
      return 'Red';
    } else if (type == 1) {
      return '#52ac5a';
    }  else if (type == 2) {
      return 'cornflowerblue';
    }
     else {
      return '#ffa500'; // Default color
    }
  }

  GetInspectionDetail()   
  {
    
    this._safetyGeneraldashboardService.GetInspectionDetail(this.inspectionId).subscribe(res=>
      {
        
       console.log(res)
       
        this.department=res.Department
        this.workareas=res.WorkArea
        this.TaskObserved=res.TaskObserved
        this.completedDate=res.CompletedDate
        this.Inspector=res.Inspector
       // this.personsInvolved=res.PersonsInvolved
        this.QuestionCategories=res.QuestionCategories;    
        this.ContractorsInvolved=res.ContractorsInvolved;  
        res.QuestionCategories.map(x=>
          {
            this.Questions=x.Questions
            this.total=this.Questions.length
          let chechhasNotApplicable = this.Questions.find(x=>x.SafeOrUnsafe!=2);
          if(chechhasNotApplicable) x.HasNotApplicable=true;
          else x.HasNotApplicable=false;
          
           // safecount=this.Questions.filter(x=> x.SafeOrUnsafe !=null && x.SafeOrUnsafe==1).length
            this.unsafecount=this.QuestionCategories.reduce((count, current) => count + current.Questions.filter(x=> x.SafeOrUnsafe !=null && x.SafeOrUnsafe==0).length, 0);
            this.totalQuestions = this.QuestionCategories.reduce((count, current) => count + current.Questions.length, 0);
          this. safecount = this.QuestionCategories.reduce((count, current) => count + current.Questions.filter(x=> x.SafeOrUnsafe !=null && x.SafeOrUnsafe==1).length, 0);
          this.CountToggleChangeNAButtonSafe=  this.QuestionCategories.reduce((count, current) => count + current.Questions.filter(x=> x.SafeOrUnsafe !=2).length, 0);
         // this.showToggleChangeNATrueButton=  this.QuestionCategories.reduce((count, current) => count + current.Questions.filter(x=> x.SafeOrUnsafe ==2).length, 0);

          x.Questions.map(x=>{
            this.QuestionImageList=x.QuestionImageList})
          })

          if(res.PersonsInvolved.length>0){
            let  persons = [];
            res.PersonsInvolved.map(x=>{
              let name = this.users.find(i=>i.UserAuto == x);
              
                persons.push(name.UserName);
              
            })

            this.personsInvolved = persons;
          
          }
         
       console.log(this.safecount, this.totalQuestions, this.unsafecount)

       //show safety icon 
       if(this.unsafecount>2)
       {
         this.safeIconcolorChange=1;
       }
       else if(this.unsafecount==1 ||this.unsafecount==2)
       {
       this.safeIconcolorChange=2
       }
       else if(this.totalQuestions==this.safecount)
       {
         this.safeIconcolorChange=3
        
       }
       else{
         this.safeIconcolorChange=4
       }

       //show toggle change button
       if(this.CountToggleChangeNAButtonSafe>0)
       {
        this.showToggleChangeNAButton=1
       }
       else if(this.CountToggleChangeNAButtonSafe<0 ||this.CountToggleChangeNAButtonSafe==0){
         this.showToggleChangeNAButton=2
       }

      })
 
  }

  loadSiteList()
  {
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
   
    // console.log('sitelist',sites)
     this.siteCodesList=sites;
  this.siteCodesList_= this.siteCodesList.filter(x=>x.Id==this.inputValuestate)
  console.log(this.siteCodesList_)
  this.SiteName= this.siteCodesList_[0].SiteName
      
   });
  }
  GetInspectionState()
  {
    
    this._safetyGeneraldashboardService.GetinspectionSiteForSafetyApp(this.inspectionId).subscribe(res=>{
      console.log("Site ID", res)
      this.inputValuestate=res.SiteId;
      

    })

  }

  GetContarctorsForSafetyApp()
  {
    this._safetyGeneraldashboardService.GetContarctorsForSafetyApp().subscribe(res=>{
    this.contractorsInvolvedList=res.filter(x=> x.ObservationDetailsId==this.inspectionId);;
      console.log(this.contractorsInvolvedList)
  
    })
   
  }

  GetUsers()
  {
    this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res=>{
      this.users=res
      console.log("persons", res)
      res.map(x=>{
      //  this.UserName=x.UserName
      }
        )
      
      
    })
  }

  ToggleFollowUpRequired(ObservationQuestionId, FollowUpRequired)
  {  
    this._safetyGeneraldashboardService.ToggleFollowUpRequired(ObservationQuestionId, FollowUpRequired).subscribe(res=>{
      this.ngOnInit();
    })
   
  }

  ToggleFollowUpCompleted(ObservationQuestionId, FollowUpCompleted)
  {  
    this._safetyGeneraldashboardService.ToggleFollowUpCompleted(ObservationQuestionId, FollowUpCompleted).subscribe(res=>{
      this.ngOnInit();
    })
    
  }

  

  // ToggleFollowUpRequired(ObservationQuestionId:number, FollowUprequired:boolean)
  // {
  //   this._safetyGeneraldashboardService.ToggleFollowUpRequired(ObservationQuestionId ,FollowUprequired).subscribe(res=>{

  //   })
  // }
  selectedValues: {[key: string]: number} = {};
  toggleSafeOrUnsafe(ObservationQuestionId, safeOrUnsafe:number )
  {
    this.type_auto =safeOrUnsafe;
    this._safetyGeneraldashboardService.ToggleSafeUnsafe(ObservationQuestionId, safeOrUnsafe).subscribe(res=>{
      this.ngOnInit();
    });
  }
  toggleSelectionSafeOrUnsafe(event:any, ObservationQuestionId)
  {
    let selectedValue : any = event.value;
    if(selectedValue==3){
      selectedValue =null;
    }
    //console.log('Selected Value for ID', ObservationQuestionId, 'is', this.selectedValues[ObservationQuestionId]);

    this._safetyGeneraldashboardService.ToggleSafeUnsafe(ObservationQuestionId, selectedValue).subscribe(res=>{
      this.ngOnInit();
    });
  }
  ToggleChangeNotApplicable(CategoryId,inspectionId,safeOrunsafe)
  {
    inspectionId=this.inspectionId
   // this.safe
 //   this.CategoryId=this.QuestionCategories.map(x=>{x.CategoryId})
    this._safetyGeneraldashboardService.ToggleChangeNotApplicable(CategoryId, inspectionId, safeOrunsafe ).subscribe(x=>{
     // this.GetInspectionDetail();
     this.ngOnInit();
    })
   
  }
  
  openEditWorkareaDepartmentDialog(){
    const dialogRef = this.dialog.open(EditWorkAreaDepartmentDialogComponent, { 
      disableClose: true,
      data:{
        InspectionID:this.inspectionId
      
      }
  
      });
  
   dialogRef.afterClosed().subscribe(result => {
     if(result==true){ 
      
     }else if(result==false){
      
      this.GetInspectionDetail();
      console.log('The dialog was closed');
     }
   });
  }


 openEditPersonInvolvedDialog(){
  const dialogRef = this.dialog.open(PersonsInvolvedDialogComponent, { 
    disableClose: true,
    data:{
      InspectionID:this.inspectionId
    
    }

    });
   // this.GetInspectionDetail();
 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){
    
    
    console.log('The dialog was closed');
    this.GetInspectionDetail();
   }
 });
}
  

openContractorsInvolvedDialog(){
  const dialogRef = this.dialog.open(ContractorsInvolvedDialogComponent, { 
    disableClose: true,
    data:{
      Id:this.inspectionId
    }

    });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    this.GetContarctorsForSafetyApp();
   }else if(result==false){
    
    this.GetInspectionDetail();
    this.GetContarctorsForSafetyApp();
    console.log('The dialog was closed');
   }
 });
}

openAddCommentDialog(CatInf:QuestionVM){
  const dialogRef = this.dialog.open(AddCommentDialogComponent, { 
    disableClose: true,
    data:{
      ObservationQuestionId:CatInf.ObservationQuestionId,
      QuestionName:CatInf.QuestionName,  
      ActionObserved: CatInf.QuestionComments.ActionObserved=="null"?"":CatInf.QuestionComments.ActionObserved,
      FollowUpActions: CatInf.QuestionComments.FollowUpActions=="null"?"":CatInf.QuestionComments.FollowUpActions,
      Responsibility: CatInf.QuestionComments.Responsibility=="null"?"":CatInf.QuestionComments.Responsibility 
    }
  });

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
    
   }else if(result==false){    
    this.GetInspectionDetail();
    console.log('The dialog was closed');
   }
 });

}




AddImageDialogComponent(CatInf:QuestionVM,img)
{
  //let image=CatInf.QuestionImageList.map(x=>{x.Image})
  
  const dialogRef = this.dialog.open(AddImageDialogComponent, { 
    disableClose: true,
    data:{
      ObservationQuestionId:CatInf.ObservationQuestionId,
      QuestionName:CatInf.QuestionName,
      Image:img.Image
    }
   
    }

    );

 dialogRef.afterClosed().subscribe(result => {
   if(result==true){ 
     console.log('true')
    this.GetInspectionDetail();
   }else if(result==false){
    
    console.log('false')
   this.GetInspectionDetail();
    console.log('The dialog was closed');
   }
   this.GetInspectionDetail();
 });
 
}
}
